import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, PageEvent, MatPaginator } from '@angular/material';
import { CarteiraDeIntegradoresFiltrosService } from '../../services/carteira-de-integradores-filtros.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { CarregandoService } from '../../services/carregando.service';
import swal from 'sweetalert2';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { GlobalService } from 'src/app/services/global.service';
import { PaginatorService } from 'src/app/services/paginator.service';

@Component({
  selector: 'app-selecionar-consulta-carteira-integradores-modal',
  templateUrl: './selecionar-consulta-carteira-integradores-modal.component.html',
  styleUrls: ['./selecionar-consulta-carteira-integradores-modal.component.scss']
})
export class SelecionarConsultaCarteiraIntegradoresModalComponent implements OnInit {
  filtros = [];

  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  idVendedor;
  administrador = false;

  idFiltro;
  descricaoFiltro;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private carteiraDeIntegradoresFiltrosService: CarteiraDeIntegradoresFiltrosService,
    private dialogRef: MatDialogRef<SelecionarConsultaCarteiraIntegradoresModalComponent>,
    private globalService: GlobalService,
    private paginatorService: PaginatorService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.idVendedor = this.data.idVendedor;
    this.idFiltro = this.data.idFiltro;
    this.descricaoFiltro = this.data.descricaoFiltro;
    this.administrador = await this.globalService.administrador();

    this.buscarFiltros();
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFiltros();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  buscarFiltros() {
    this.carregandoService.mostra('buscarFiltros');

    this.carteiraDeIntegradoresFiltrosService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.idVendedor).subscribe(dados => {
      this.filtros = dados.itens;

      this.paginacao.total = dados.total;

      this.carregandoService.esconde('buscarFiltros');
    }, (erro) => {
      this.carregandoService.esconde('buscarFiltros');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarFiltro(filtro) {
    this.dialogRef.close({
      idFiltro: filtro.id,
      descricaoFiltro: filtro.descricao,
      filtrosSelecionados: JSON.parse(filtro.filtrosJson).filtros,
      colunasSelecionadas: JSON.parse(filtro.filtrosJson).colunas
    });
  }

  excluirFiltro(filtroId) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Filtro?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('exluirFiltro');

        this.carteiraDeIntegradoresFiltrosService.excluirFiltro(filtroId).subscribe(dados => {
          this.buscarFiltros();
          this.idFiltro = undefined;
          this.descricaoFiltro = undefined;
          this.carregandoService.esconde('exluirFiltro');
        }, (erro) => {
          this.carregandoService.esconde('exluirFiltro');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}